import type { AccountListing } from "@/lib/authv2/api";

type Props = {
  accounts: AccountListing[];
  onPick: (casdoorSub: string) => void;
  onAdd: () => void;
};

export function AccountChooser({ accounts, onPick, onAdd }: Props) {
  return (
    <div className="space-y-3">
      {accounts.length > 0 ? (
        <ul className="space-y-2">
          {accounts.map((a) => (
            <li key={a.casdoor_sub}>
              <button
                onClick={() => onPick(a.casdoor_sub)}
                className="flex w-full items-center gap-3 rounded-md border px-3 py-2 text-left hover:bg-muted/10"
              >
                {/* avatar_url ở đây LUÔN là địa chỉ đầy đủ do worker ghi sẵn
                    sau khi đã kiểm ảnh có thật — dùng thẳng, không tra danh
                    sách nhân sự (màn hình này hiện ra trước khi đăng nhập). */}
                {a.avatar_url ? (
                  <img
                    src={a.avatar_url}
                    alt=""
                    className="h-8 w-8 shrink-0 rounded-full object-cover"
                  />
                ) : (
                  <span
                    aria-hidden="true"
                    className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/20 text-sm font-semibold"
                  >
                    {a.display_name.trim()[0] ?? "?"}
                  </span>
                )}
                <span className="flex-1 truncate">{a.display_name}</span>
                {a.last_login_at ? (
                  <span className="text-xs text-muted">
                    {new Date(a.last_login_at).toLocaleDateString("vi-VN")}
                  </span>
                ) : null}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
      <button
        onClick={onAdd}
        className="w-full rounded-md border border-dashed px-3 py-2 text-sm hover:bg-muted/10"
      >
        + Thêm tài khoản (đăng nhập với Casdoor)
      </button>
    </div>
  );
}
